export const MEDIA_PATH = '/instruction_gifs/';

//phaser stuff
export const assetsPath = `/game_assets/`;
export const phaserAssetsPath = `${assetsPath}/sprites/phaser_game/`;
export const uiAssetsPath = `${phaserAssetsPath}phaser_game_ui/`;
export const statusAssetsPath = `${assetsPath}status_icons/`;
export const customizationsPath = `${assetsPath}sprites/phaser_game/character_sprites/`;
export const customizationsUIPath = `${customizationsPath}ui_sprites/`;
export const customizationsSpritePath = `${customizationsPath}sprite_assets/`;
export const customizationsNPCPath = `${customizationsPath}npc_sprites/`;
export const defaultHairPath = `${customizationsPath}hair/orange_ponytail.png`;
export const defaultBodyPath = `${customizationsPath}clothes/blue-loose-shirt-m.png`;
export const defaultPantsPath = `${customizationsPath}pants/brown-long-pants.png`;
export const defaultShoesPath = `${customizationsPath}shoes/brown-shoes.png`;
export const phaserAudioAssetsPath = `${assetsPath}phaser_game_audio/`;
export const ambienceAudioPath = `${phaserAudioAssetsPath}ambience/`;
export const miscAudioPath = `${phaserAudioAssetsPath}misc/`;
export const particlesPath = `${assetsPath}Super Pixel Effects Pack 1/spritesheet/`;
export const spellIconsPath = `${assetsPath}SpellIcons/`;
export const definitionImagesPath = `${assetsPath}definition_images/`;
export const exampleImagesPath = `${assetsPath}example_images/`;

export const animationsPath = `${assetsPath}animations/`;
export const audioPath = `${assetsPath}audio/`;
export const tilemapsPath = `${assetsPath}tilemaps/`;
export const vfxPath = `${assetsPath}vfx/`;

//map stuff
export const numberOfMaps = 7;
